/***
*
*   usePermissions hook
*   Provides permission checking utilities
*
**********/

import { useSelector } from 'react-redux';

/**
 * Hook to check permissions in components
 */
export function usePermissions() {
  const rbacState = useSelector((state) => state.rbac);
  const { myPermissions, loading } = rbacState;

  const permissions = myPermissions?.permissions || {};
  const menus = myPermissions?.menus || [];
  const roleKey = myPermissions?.role_key || null;
  const roleName = myPermissions?.role_name || null;

  /**
   * Check if user can perform action on a menu
   * @param {string} menuKey - e.g. 'dashboard', 'feedback'
   * @param {string} action - 'view', 'edit', 'delete'
   */
  const can = (menuKey, action) => {
    return permissions?.[menuKey]?.[action] === true;
  };

  /**
   * Check if the user can view a menu
   */
  const canView = (menuKey) => can(menuKey, 'view');
  const canEdit = (menuKey) => can(menuKey, 'edit');
  const canDelete = (menuKey) => can(menuKey, 'delete');

  /**
   * Get accessible nav items
   */
  const getNavItems = () => {
    return menus.map(menu => ({
      label: menu.label,
      icon: menu.icon,
      link: menu.path
    }));
  };

  return {
    permissions,
    menus,
    roleKey,
    roleName,
    loading,
    can,
    canView,
    canEdit,
    canDelete,
    getNavItems
  };
}